import { ClosedAccounts } from '../../../investment/components/ClosedAccounts';

export default function ApexClosedAccountsPage() {
    return <ClosedAccounts />;
}
